import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_GENERAL_SETTINGS_AUTO_APPROVE_ROUTE_NAME = Symbol('admin.settings.auto-approve');
export const TRANSLATION_GROUP_GENERAL_SETTINGS_AUTO_APPROVE = Symbol('general-settings.auto-approve');

export const SETTINGS_AUTO_APPROVE_LIST_URL = 'admin/auto_approve_locales/list';
export const SETTINGS_AUTO_APPROVE_SAVE_URL = 'admin/auto_approve_locales/save';

export const SETTINGS_AUTO_APPROVE_LIST_QUERY_KEY = 'general-settings.auto-approve.list';
export const SETTINGS_AUTO_APPROVE_SAVE_QUERY_KEY = 'general-settings.auto-approve.save';

export const ADMIN_GENERAL_SETTINGS_AUTO_APPROVE_PERMISSIONS = {
  AUTOAPPROVELOCALES_SHOW: new Permission(PermissionsList.admin.AUTOAPPROVELOCALES_SHOW),
  AUTOAPPROVELOCALES_EDIT: new Permission(PermissionsList.admin.AUTOAPPROVELOCALES_EDIT),
};
